import { useQuery } from '@connectrpc/connect-query';

import { getMe } from '../../../gen/user/v1/user-UserService_connectquery';
import { isNetworkError } from '../../../lib/apiError';

export const useCurrentUser = () => {
	const { data, isLoading, isError, refetch } = useQuery(
		getMe,
		{},
		{
			staleTime: Infinity,
			// Every page load starts with this call, so a dropped connection or a cold API instance
			// gets one more attempt; an Unauthenticated answer must reach the login redirect at once.
			retry: (failureCount, error) => failureCount < 1 && isNetworkError(error),
		},
	);

	return { user: data?.user, isLoading, isError, refetch };
};
